export enum AssetGroupType {
  AURORA = 'aurora'
}
